import { useContext } from "react";
import { ToastContext } from "./ToastProvider.tsx";

export function useToast() {
  return useContext(ToastContext);
}
